<template lang="pug">
page-template.page-parts.pb-16(:title="title", fluid)
  v-container
    template(v-if="categories.length")
      .text-center.font-weight-bold.mb-3 Filtrar por tipo de máquina
      .page-parts-categories.d-flex.justify-center.mb-8
        v-btn.rounded-pill(
          v-for="{ key, title } in categories",
          @click="filterCategory(key)",
          :key="title",
          :outlined="category !== key",
          color="primary",
          large,
          depressed
        )
          | {{ title }}
      v-divider.mb-6
  template(v-if="!loading")
    template(v-if="items.length")
      .page-parts-list.justify-center.px-md-10
        part-card(
          v-for="({ img, title, to }, i) in items",
          :key="i",
          :img="img",
          :title="title",
          :to="to"
        )
    .d-flex.justify-center(v-else)
      v-alert.mx-auto(type="info", color="secondary") Nenhuma máquina disponível.
  .py-10.d-flex.justify-center(v-else)
    v-progress-circular(size="50", color="primary", indeterminate)
</template>

<script>
import PageTemplate from "@/components/templates/Page.vue";
import CustomTitle from "@/components/shell/CustomTitle.vue";
import PartCard from "@/components/cards/Part";
import { formatToURL } from "@/components/utils";

const _config = {
  mod: "parts",
  path: "/pecas",
  title: "Peças",
};

export default {
  data: () => ({
    loading: true,
    title: _config.title,
  }),
  computed: {
    items() {
      let items = this.$rest(_config.mod).list || [];

      if (this.category) {
        items = items.filter(
          ({ category }) =>
            category && formatToURL(category.title) === this.category
        );
      }

      return items.map(({ id, img, title }) => ({
        img: img ? this.files + img : "",
        title,
        to: `${_config.path}/${formatToURL(`${title}-${id}`)}`,
      }));
    },
    categories() {
      return (this.$rest(_config.mod).list || [])
        .reduce((r, { category }) => {
          if (category && !r.find((item) => item.id === category.id)) r.push(category);
          return r;
        }, [])
        .map(({ title }) => ({
          key: formatToURL(title),
          title,
        }));
    },
    category: {
      get() {
        return this.$route.query.categoria;
      },
      set(v) {
        this.$router.push({ query: v ? { categoria: v } : {} });
      },
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    filterCategory(key) {
      if (this.category === key) this.category = null;
      else this.category = key;
    },
  },
  beforeCreate() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
  components: {
    PageTemplate,
    CustomTitle,
    PartCard,
  },
};
</script>

<style>
.page-parts-list {
  display: grid;
  gap: 30px !important;
  grid-template-columns: repeat(auto-fit, 280px);
}

@media screen and (max-width: 960px) {
  .page-parts-list {
    grid-template-columns: repeat(auto-fit, 280px);
  }
}

.page-parts-categories {
  gap: 12px;
}
</style>
